var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellConcierge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488 400H24C10.746 400 0 410.742 0 424C0 437.254 10.746 448 24 448H488C501.254 448 512 437.254 512 424C512 410.742 501.254 400 488 400ZM80 352C80 255 159 176 256 176S432 255 432 352V368H480V352C480 239.125 396.5 146.125 288 130.5V112H312C325.254 112 336 101.254 336 88C336 74.742 325.254 64 312 64H200C186.746 64 176 74.742 176 88C176 101.254 186.746 112 200 112H224V130.5C115.5 146.125 32 239.125 32 352V368H80V352Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellConcierge);
export default __webpack_public_path__ + "static/media/bell-concierge.49279b426a6ced342f4099a3296d3d3a.svg";
export { ForwardRef as ReactComponent };